document.querySelectorAll('[id^="Details-"] summary').forEach(e => {
  e.setAttribute("role", "button"), e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open")), e.nextElementSibling.getAttribute("id") && e.setAttribute("aria-controls", e.nextElementSibling.id), e.addEventListener("click", e => {
      e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"))
  }), e.closest("header-drawer") || e.parentElement.addEventListener("keyup", onKeyUpEscape)
});
class MenuDrawer extends HTMLElement {
  constructor() {
      super(), this.mainDetailsToggle = this.querySelector("details"), "iPhone" === navigator.platform && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`), this.addEventListener("keyup", this.onKeyUp.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.bindEvents()
  }
  bindEvents() {
      this.querySelectorAll("summary").forEach(e => e.addEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll("button").forEach(e => e.addEventListener("click", this.onCloseButtonClick.bind(this)))
  }
  onKeyUp(e) {
      if ("ESCAPE" === e.code.toUpperCase()) {
          let t = e.target.closest("details[open]");
          t && (t === this.mainDetailsToggle ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(t))
      }
  }
  onSummaryClick(e) {
      function t() {
          r.nextElementSibling.removeEventListener("transitionend", t)
      }
      let r = e.currentTarget,
          i = r.parentNode,
          s = i.closest(".has-submenu"),
          n = i.hasAttribute("open"),
          a = window.matchMedia("(prefers-reduced-motion: reduce)");
      i === this.mainDetailsToggle ? (n && e.preventDefault(), n ? this.closeMenuDrawer(e, r) : this.openMenuDrawer(r)) : setTimeout(() => {
          i.classList.add("menu-opening"), r.setAttribute("aria-expanded", !0), s && s.classList.add("submenu-open"), !a || a.matches ? t() : r.nextElementSibling.addEventListener("transitionend", t)
      }, 0)
  }
  openMenuDrawer(e) {
      setTimeout(() => {
          this.mainDetailsToggle.classList.add("menu-opening")
      }), e.setAttribute("aria-expanded", !0), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
  closeMenuDrawer(e, t = !1) {
      void 0 === e || (this.mainDetailsToggle.classList.remove("menu-opening"), this.mainDetailsToggle.querySelectorAll("details").forEach(e => {
          e.removeAttribute("open"), e.classList.remove("menu-opening")
      }), this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach(e => {
          e.classList.remove("submenu-open")
      }), document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`), this.closeAnimation(this.mainDetailsToggle))
  }
  onFocusOut() {
      setTimeout(() => {
          this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer()
      })
  }
  onCloseButtonClick(e) {
      let t = e.currentTarget.closest("details");
      this.closeSubmenu(t)
  }
  closeSubmenu(e) {
      let t = e.closest(".submenu-open");
      t && t.classList.remove("submenu-open"), e.classList.remove("menu-opening"), e.querySelector("summary").setAttribute("aria-expanded", !1), this.closeAnimation(e)
  }
  closeAnimation(e) {
      let t, r = i => {
          void 0 === t && (t = i);
          let s = i - t;
          400 > s ? window.requestAnimationFrame(r) : e.removeAttribute("open")
      };
      window.requestAnimationFrame(r)
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
      super()
  }
  openMenuDrawer(e) {
      this.header = this.header || document.getElementById("shopify-section-header"), this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0, document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom-this.borderOffset)}px`), this.header.classList.add("menu-open"), setTimeout(() => {
          this.mainDetailsToggle.classList.add("menu-opening")
      }), e.setAttribute("aria-expanded", !0), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
  closeMenuDrawer(e, t) {
      super.closeMenuDrawer(e, t), this.header.classList.remove("menu-open")
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
      super(), this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)), this.addEventListener("keyup", e => {
          "ESCAPE" === e.code.toUpperCase() && this.hide()
      }), this.classList.contains("media-modal") ? this.addEventListener("pointerup", e => {
          "mouse" !== e.pointerType || e.target.closest("deferred-media, product-model") || this.hide()
      }) : this.addEventListener("click", e => {
          e.target === this && this.hide()
      })
  }
  connectedCallback() {
      this.moved || (this.moved = !0, document.body.appendChild(this))
  }
  show(e) {
      this.openedBy = e;
      let t = this.querySelector(".template-popup");
      document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), t && t.loadContent(), window.pauseAllMedia()
  }
  hide() {
      document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")), this.removeAttribute("open"), window.pauseAllMedia()
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
      super();
      let e = this.querySelector("button");
      e && e.addEventListener("click", () => {
          let t = document.querySelector(this.getAttribute("data-modal"));
          t && t.show(e)
      })
  }
}
customElements.define("modal-opener", ModalOpener);
class QuantityInput extends HTMLElement {
  constructor() {
      super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
          bubbles: !0
      }), this.querySelectorAll("button").forEach(e => e.addEventListener("click", this.onButtonClick.bind(this)))
  }
  onButtonClick(e) {
      e.preventDefault();
      let t = this.input.value;
      "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent)
  }
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(e => {
      e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
  }), document.querySelectorAll(".js-vimeo").forEach(e => {
      e.contentWindow.postMessage('{"method":"pause"}', "*")
  }), document.querySelectorAll("video").forEach(e => e.pause()), document.querySelectorAll("product-model").forEach(e => {
      e.modelViewerUI && e.modelViewerUI.pause()
  })
}

function debounce(e, t) {
  let r;
  return (...i) => {
      clearTimeout(r), r = setTimeout(() => e.apply(this, i), t)
  }
}

function onKeyUpEscape(e) {
  if ("ESCAPE" === e.code.toUpperCase()) {
      let t = e.target.closest("details[open]");
      if (t) {
          let r = t.querySelector("summary");
          t.removeAttribute("open"), r.setAttribute("aria-expanded", !1), r.focus()
      }
  }
}
customElements.define("quantity-input", QuantityInput);
const serializeForm = e => {
  let t = {},
      r = new FormData(e);
  for (let i of r.keys()) {
      let s = /(?:^(properties\[))(.*?)(?:\]$)/;
      s.test(i) ? (t.properties = t.properties || {}, t.properties[s.exec(i)[2]] = r.get(i)) : t[i] = r.get(i)
  }
  return JSON.stringify(t)
};

function fetchConfig(e = "json") {
  return {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          Accept: `application/${e}`
      }
  }
}
void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function(e, t) {
  return function() {
      return e.apply(t, arguments)
  }
}, Shopify.setSelectorByValue = function(e, t) {
  for (var r, i = 0, s = e.options.length; i < s; i++)
      if (t == (r = e.options[i]).value || t == r.innerHTML) return e.selectedIndex = i, i
}, Shopify.addListener = function(e, t, r) {
  e.addEventListener ? e.addEventListener(t, r, !1) : e.attachEvent("on" + t, r)
}, Shopify.postLink = function(e, t) {
  var r = (t = t || {}).method || "post",
      i = t.parameters || {},
      s = document.createElement("form");
  for (var n in s.setAttribute("method", r), s.setAttribute("action", e), i) {
      var a = document.createElement("input");
      a.setAttribute("type", "hidden"), a.setAttribute("name", n), a.setAttribute("value", i[n]), s.appendChild(a)
  }
  document.body.appendChild(s), s.submit(), document.body.removeChild(s)
}, Shopify.CountryProvinceSelector = function(e, t, r) {
  this.countryEl = document.getElementById(e), this.provinceEl = document.getElementById(t), this.provinceContainer = document.getElementById(r.hideElement || t), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
}, Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
      var e = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler()
  },
  initProvince: function() {
      var e = this.provinceEl.getAttribute("data-default");
      e && 0 < this.provinceEl.options.length && Shopify.setSelectorByValue(this.provinceEl, e)
  },
  countryHandler: function() {
      var e = this.countryEl.options[this.countryEl.selectedIndex],
          t = JSON.parse(e.getAttribute("data-provinces"));
      if (this.clearOptions(this.provinceEl), t && 0 == t.length) this.provinceContainer.style.display = "none";
      else {
          for (var e, r = 0; r < t.length; r++)(e = document.createElement("option")).value = t[r][0], e.innerHTML = t[r][1], this.provinceEl.appendChild(e);
          this.provinceContainer.style.display = ""
      }
  },
  clearOptions: function(e) {
      for (; e.firstChild;) e.removeChild(e.firstChild)
  },
  setOptions: function(e, t) {
      for (var r, i = 0; i < t.length; i++)(r = document.createElement("option")).value = t[i], r.innerHTML = t[i], e.appendChild(r);
      t.length
  }
};
class DeferredMedia extends HTMLElement {
  constructor() {
      super();
      let e = this.querySelector('[id^="Deferred-Poster-"]');
      e && e.addEventListener("click", this.loadContent.bind(this))
  }
  loadContent(e = !0) {
      if (window.pauseAllMedia(), !this.getAttribute("loaded")) {
          let t = document.createElement("div");
          t.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
          let r = this.appendChild(t.querySelector("video, model-viewer, iframe"));
          e && r.focus()
      }
  }
}
customElements.define("deferred-media", DeferredMedia);
class OpenFilterDrawer extends HTMLElement {
  constructor() {
      super(), this.button = this.querySelector(".slidebarfilter"), this.button.addEventListener("click", this.openMobileFilterDrawer.bind(this))
  }
  openMobileFilterDrawer() {
      let e = document.querySelector(".shop-grid-sidebar");
      e.classList.toggle("active")
  }
}
customElements.define("open-filter", OpenFilterDrawer);
class CloseFilterDrawer extends HTMLElement {
  constructor() {
      super(), this.button = this.querySelector(".remove-sidebar"), this.button.addEventListener("click", this.closeMobileFilterDrawer.bind(this))
  }
  closeMobileFilterDrawer() {
      let e = document.querySelector(".shop-grid-sidebar");
      e.classList.toggle("active")
  }
}
customElements.define("close-filter", CloseFilterDrawer);
class QuickView extends HTMLElement {
  constructor() {
      super(), this.button = this.querySelectorAll(".quickview-btn"), this.button.forEach(e => e.addEventListener("click", this.openQuickView.bind(this)))
  }
  openQuickView(e) {
      this.querySelector(".quickview-btn").classList.add("loading"), this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
      let t = e.target.closest(".quickview_container"),
          r = t.querySelector(".quickview-btn"),
          i = document.querySelector("#quickview_content"),
          s = r.dataset.productHandle,
          n = `/products/${s}`,
          a = document.querySelector("#qv_close_btn"),
          o = document.querySelector("#qv_loader"),
          l = document.getElementById("quickview_modal");
      fetch(`${n}?view=qv`).then(e => e.text()).then(e => {
          let t = new DOMParser().parseFromString(e, "text/html");
          l.style.display = "block";
          let r = t.getElementById("shopify-section-pdp-gallery").innerHTML;
          i.innerHTML = r, o.classList.add("hidden"), document.getElementsByTagName("body")[0].classList.add("stop_scrolling"), document.querySelector("#quickview_content .variant_swatch").setAttribute("data-update-url", "false");
          let s = document.querySelector("#quickview_content .product_thumb_holder_pdp");
          let productOptions = JSON.parse(this.querySelector('.quickview-btn').getAttribute('data-options'))
          for (let x=0; x < productOptions.length; x++){
            document.querySelector(`#quickview_content input[value="${productOptions[x]}"]`).click();
          }
          setTimeout(() => {
            if(document.querySelector('#quickview_content [data-size-image="true"]')){
              document.querySelector('#quickview_content [data-size-image]').setAttribute('data-size-image',false)
            }
          }, 500);

          s && s.remove(), window.setTimeout(() => {
              document.querySelector(".product_thumb_holder_qv .product_media_thumb.slick-current.slick-active").click()
          })
      }).catch(e => {
          console.log(e)
      }).finally(() => {
          this.querySelector(".quickview-btn").classList.remove("loading"), this.querySelector(".loading-overlay__spinner").classList.add("hidden");
          let lowInvScript = document.getElementById("low-inventory-script");
          if(lowInvScript){
            let scriptText = lowInvScript.textContent;
            eval(scriptText);
          }
      }), a.addEventListener("click", () => {

          i.innerHTML = "", l.style.display = "none";
          let e = document.querySelector("#cart-drawer");
          window.setTimeout(() => {
              o.classList.remove("hidden")
          }, 1e3), e.classList.contains("show") || document.getElementsByTagName("body")[0].classList.remove("stop_scrolling")
      })
  }
}
customElements.define("quick-view", QuickView);
class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onVariantClick);
    this.addEventListener('change', this.onVariantChange);
    
    document
      .querySelectorAll(".variant_name")
      .forEach((e) =>
        e.addEventListener("click", () => {
          const productFormInput = e.closest(".product_form_input");
          productFormInput.querySelector(".selected_value").innerHTML =
            e.dataset.variant;
          productFormInput
            .closest(".product_info_wrapper")
            .querySelector("product-form")
            .classList.remove("disabled");
        })
      );
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.toggleVariantVisibility(); 
    }
  }

  onVariantClick() {
    const quickviewContent = this.closest('#quickview_content');

    const updateOperations = () => {
        this.updateOptions();
        this.updateMasterId();
        this.updateMedia();
    };

    if (quickviewContent) {
        setTimeout(updateOperations, 500);
    } else {
        updateOperations();
    }
}

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    //Enavi variant image change
    var targetVariantImageAltText = this.currentVariant.option1; 
    const sizeImageMedia = this.closest('#main-product-gallery-container').querySelector(`[data-media-id] [alt="${targetVariantImageAltText}"]`);
    if(sizeImageMedia){
      sizeImageMedia.click();
    }else{
      const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      const mediaElement = document.querySelector(`[data-media-id="${mediaId}"]`);
  
      if (!mediaElement) return;
  
      mediaElement.click();
    }

    if(this.closest('#quickview_content')){
      return;
    }

    setTimeout(() => {
      var headerOffset = 120;
      var elementPosition = document.querySelector('.pdp-gallery-section').getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }, 1000);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    const params = new URLSearchParams(window.location.search);
    params.set('variant', this.currentVariant.id);

    const newUrl = `${this.dataset.url}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  }

  updateShareUrl() {
    const shareElement = document.getElementById(`Share-${this.dataset.section}`);
    if (shareElement) {
      shareElement.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const documentFragment = parser.parseFromString(html, "text/html");
        const priceElementId = `price-${this.dataset.section}`;
        const stockElementId = `stock-${this.dataset.section}`;
        const mobileStockElementId = `mobile-stock-${this.dataset.section}`;
        const estimateDateElementId = `estimate_date-${this.dataset.section}`;

        const priceElements = document.querySelectorAll(`#${priceElementId}`);
        const newPriceElement = documentFragment.getElementById(priceElementId);
        const stockElement = document.getElementById(stockElementId);
        const newStockElement = documentFragment.getElementById(stockElementId);
        const mobileStockElement = document.getElementById(mobileStockElementId);
        const newMobileStockElement = documentFragment.getElementById(mobileStockElementId);
        const estimateDateElement = document.getElementById(estimateDateElementId);
        const newEstimateDateElement = documentFragment.getElementById(estimateDateElementId);
        
        priceElements.forEach((element) => {
          if (newPriceElement && element) {
            element.innerHTML = newPriceElement.innerHTML;
          }
        });

        if (newStockElement && stockElement) {
          stockElement.innerHTML = newStockElement.innerHTML;
        }

        if (newMobileStockElement && mobileStockElement) {
          mobileStockElement.innerHTML = newMobileStockElement.innerHTML;
        }

        if (newEstimateDateElement && estimateDateElement) {
          estimateDateElement.classList.toggle('hidden', newEstimateDateElement.classList.contains('hidden'));
          estimateDateElement.innerHTML = newEstimateDateElement.innerHTML;
        }

        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          const savingsPercentage = ((parseFloat(this.currentVariant.compare_at_price) / 100 - parseFloat(this.currentVariant.price) / 100) / (parseFloat(this.currentVariant.compare_at_price) / 100)) * 100;
          $(".product_price_save").html("SAVE " + parseInt(savingsPercentage) + "%").show();
        } else {
          $(".product_price_save").hide();
        }

        let stockText = window.variantStrings.soldOut;
        if (newStockElement.getAttribute('data-vartag-preorder') && newStockElement.getAttribute('data-incoming') && this.currentVariant.available) {
          stockText = window.variantStrings.preOrder;
        } else if (newStockElement.innerHTML.trim().toLowerCase() === "coming soon") {
          stockText = "Coming Soon";
        }

        const priceElementSection = document.getElementById(`price-${this.dataset.section}`);
        if (priceElementSection) {
          priceElementSection.classList.remove("hidden");
        }

        this.toggleAddButton(!this.currentVariant.available, stockText);
      });
}

    toggleVariantVisibility() {
    const allVariantElements = document.querySelectorAll("[class^='variant-']");
    const selectedVariantClass = `variant-${this.currentVariant.id}`;

    allVariantElements.forEach((element) => {
      if (element.classList.contains(selectedVariantClass)) {
        element.classList.remove('hidden'); // Show the selected variant
      } else {
        element.classList.add('hidden'); // Hide other variants
      }
    });
    console.log(allVariantElements);
    console.log(selectedVariantClass);
    console.log(`Visibility updated for variant: ${this.currentVariant.id}`);
    }


  toggleAddButton(disabled = true, text, showNotification = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonSpan = productForm.querySelector('[name="add"] > span');
    const bisButton = productForm.querySelector('.k_notify');
    if (!addButton) return;

    addButtonSpan.textContent = window.variantStrings.addToCart;
    if (text === 'Coming Soon' || (text === 'Sold out' && disabled)) {
      addButtonSpan.textContent = 'Coming Soon';
      bisButton.style.display = 'block';
      addButton.style.display = 'none';
    } else {
      addButton.style.display = '';
      if (bisButton) {
        bisButton.style.display = 'none';
      }
      
      if (addButton && disabled) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonSpan.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonSpan.textContent = (text === window.variantStrings.preOrder) ? window.variantStrings.preOrder : window.variantStrings.addToCart;
      }
    }
  }

  setUnavailable() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonSpan = productForm.querySelector('[name="add"] > span');
    const priceElement = document.getElementById(`price-${this.dataset.section}`);

    if (addButton) {
      addButtonSpan.textContent = window.variantStrings.unavailable;
      if (priceElement) {
        priceElement.classList.add("hidden");
      }
    }
  }

  getVariantData() {
    if (!this.variantData) {
      this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);


/* functions for auto add */
function addLoader(){
    document.querySelector('cart-drawer .cart-drawer-wrapper .js-contents').classList.add('loading')
}
function removeLoader(){
    document.querySelector('cart-drawer .cart-drawer-wrapper .js-contents').classList.remove('loading')
}
function autoAddedItem(element){

    fetch(`${window.internationalRoutes.cartUrl}`).then(response => response.json()).then(data => {
        updatecart_count();
        let variantId = parseInt(window.autoAddItem[parseInt(element.parentElement.parentElement.parentElement.querySelector('[name="id"]').value)]);

        if(!variantId){return;}

        let items = data.items;
        let findVariant = items.find(item => {
            return Number(item.variant_id) === Number(variantId);
        });

        if (findVariant) {
            addLoader();
            refreshCart();
            return;
        }

        let formData = {
            'items': [{
                'id': variantId,
                'quantity': 1,
                'properties': { '_gift-item': 'true' }
            }]
        };
        fetch(`${window.internationalRoutes.addUrl}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
        }).then(response => {
            addLoader();
            updatecart_count();
            return response.text()
        }).then(response => {
            refreshCart()
        });
    });
    
}
function autoAddItemOnValue(){
    fetch(`${window.internationalRoutes.cartUrl}`).then(response => response.json()).then(data => {
        let cartTotal = data.total_price;
        for (let value in window.autoAddOnValue){
         let autoAddOnValueCart = data.items.filter(y => y.properties[`_gift-item-value`] != undefined);
         var containsGiftItem = [];
         autoAddOnValueCart.forEach(function(item){
            if (item.properties['_gift-item-value'] == window.autoAddOnValue[value]){
                containsGiftItem.push('true' + window.autoAddOnValue[value]);
            }
        })
          if (cartTotal > (value * 100) && !containsGiftItem.includes('true' + window.autoAddOnValue[value])){

            let formData = {
              'items': [{
               'id': window.autoAddOnValue[value],
               'quantity': 1,
               'properties': { '_gift-item': 'true', '_gift-item-value': window.autoAddOnValue[value] }
               }]
             };
            fetch(`${window.internationalRoutes.addUrl}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            }).then(response => {
                addLoader()
                updatecart_count()
                return response.json() }).then(response => {
                refreshCart()
            })
          }
        }
      })  
}
function removeItemOnValue(){
    fetch(`${window.internationalRoutes.cartUrl}`).then(response => {
        return response.json()}).then(data =>{
        let cartItems = data.items
        let cartTotal = data.total_price
            for (let i in cartItems){
            var itemToRemoveAddOnValue;
            var newCartTotal = cartTotal
            if (cartItems.filter(y => y.properties['_gift-item'] != undefined)){
            cartItems.filter(y => y.properties['_gift-item'] != undefined).forEach(function(item, index){
            newCartTotal = newCartTotal - item.line_price
            })
            }
            try{
            for (let x in window.autoAddOnValue){
              if (window.autoAddOnValue[x] == cartItems[i].id && cartItems[i].properties['_gift-item'] != undefined && newCartTotal < parseInt(x)){
                  itemToRemoveAddOnValue = window.autoAddOnValue[x] 
              } else {
                itemToRemoveAddOnValue = null;
              }
            }
                let dataJSON = JSON.parse('{"updates":{"' + itemToRemoveAddOnValue + '":0}}')
                    if (itemToRemoveAddOnValue != null){
                    fetch(`${window.internationalRoutes.updateUrl}`, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                    }, body: JSON.stringify(dataJSON) 
                    }).then(function (data) {
                        updatecart_count()
                        refreshCart();
                    })
                    }
                } catch {
                console.log('cart item does not exist')
                }
            }
        })
}
function removeItem(quantity, lineId){
    fetch(`${window.internationalRoutes.cartUrl}`).then(response => {
        addLoader()
        return response.json()}).then(data =>{
        let cartItems = data.items
      if (quantity == 0){
          cartItems.filter(item => item.properties['_gift-item'] != undefined).forEach(function(item){
            if (item.id == window.autoAddItem[lineId]){
              try{
                let itemToRemove = window.autoAddItem[lineId]
                let dataJSON = JSON.parse('{"updates":{"' + itemToRemove + '":0}}')
                fetch(`${window.internationalRoutes.updateUrl}`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                      'Content-Type': 'application/json',
                  }, body: JSON.stringify(dataJSON) 
                  }).then(function (data) {
                    updatecart_count();
                    refreshCart();
                  })
              } catch {
                console.log('nothing to remove')
              }
            }
          })
        }
      }).then(()=>{
        removeItemOnValue()
      }).finally(()=>{
        removeLoader()
      })
}
function updatecart_count(){
    $.getJSON(`${window.location.origin}/cart.json`, function(cart) {
        var bundle_count_cart_id=[],cart_item_count=0; 
        $.each(cart.items, function(ci, item) {
            if (item.properties._Bundle_id != undefined){
                if(bundle_count_cart_id.indexOf(item.properties._Bundle_id) < 0) {
                    bundle_count_cart_id.push(item.properties._Bundle_id);
                    cart_item_count++;
                }
            }else{
                cart_item_count = cart_item_count + item.quantity;
            }
        });
        if (document.getElementById('cart-count-bubble-count') != null){
            document.getElementById('cart-count-bubble-count').innerText = '('+cart_item_count+')';
        }
        $('.cart-drawer-heading span').innerText = '('+cart_item_count+')';
    });
}
function refreshCart(){
    fetch(`${window.internationalRoutes.homeUrl}`).then(response => response.text()).then(data => {
        console.log('refreshing cart')
        let parser = new DOMParser();
        let doc = parser.parseFromString(data, 'text/html')
        let newCartDrawer = doc.querySelector('#cart-drawer').innerHTML;
        document.querySelector('#cart-drawer').innerHTML = newCartDrawer;
        removeLoader()
    });
}
/* end functions for auto add */

class CartNotification extends HTMLElement {
  constructor() {
      super(), this.notification = document.getElementById("cart-notification"), this.onBodyClick = this.handleBodyClick.bind(this), this.notification.addEventListener("keyup", e => "Escape" === e.code && this.close())
  }
  open() {
      this.notification.classList.add("animate", "active"), this.notification.addEventListener("transitionend", () => {
          this.notification.focus(), trapFocus(this.notification)
      }, {
          once: !0
      }), document.body.addEventListener("click", this.onBodyClick)
  }
  close() {
      this.notification.classList.remove("active"), document.body.removeEventListener("click", this.onBodyClick)
  }
  renderContents(e) {
      this.productId = e.id, this.getSectionsToRender().forEach(t => {
          document.getElementById(t.id).innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector)
      }), this.open(), document.querySelector("#cart-drawer").classList.add("show"), document.getElementsByTagName("body")[0].classList.add("stop_scrolling")
  }
  getSectionsToRender() {
      return [{
          id: "cart-notification-product",
          selector: `#cart-notification-product-${this.productId}`
      }, {
          id: "cart-notification-button"
      }, {
          id: "cart-icon-bubble"
      }, {
          id: "cart-drawer",
          selector: "#cart-drawer"
      }]
  }
  getSectionInnerHTML(e, t = ".shopify-section") {
      return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML
  }
  handleBodyClick(e) {
      let t = e.target;
      if (t !== this.notification && !t.closest("cart-notification")) {
          let r = t.closest("details-disclosure");
          this.activeElement = r ? r.querySelector("summary") : null, this.close()
      }
  }
  setActiveElement(e) {
      this.activeElement = e
  }
}
customElements.define("cart-notification", CartNotification), customElements.get("product-form") || customElements.define("product-form", class extends HTMLElement {
  constructor() {
      super(), this.form = this.querySelector("form"), this.form.addEventListener("submit", this.onSubmitHandler.bind(this)), this.cartNotification = document.querySelector("cart-notification")
  }
  onSubmitHandler(e) {
      e.preventDefault();
      let t = this.querySelector('[type="submit"]');
      if (!t.classList.contains("loading")) {
          this.handleErrorMessage(), this.cartNotification.setActiveElement(document.activeElement), t.setAttribute("aria-disabled", !0), t.classList.add("loading"), this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
          let r = fetchConfig("javascript");
          r.headers["X-Requested-With"] = "XMLHttpRequest", r.body = JSON.stringify({
              ...JSON.parse(serializeForm(this.form)),
              sections: this.cartNotification.getSectionsToRender().map(e => e.id),
              sections_url: window.location.pathname
          }), fetch(`${window.internationalRoutes.addUrl}`, r).then(e => e.json()).then(e => e.status ? void this.handleErrorMessage(e.description) : void this.cartNotification.renderContents(e)).catch(e => {
              console.error(e)
          }).finally(() => {
              t.classList.remove("loading"), t.removeAttribute("aria-disabled"), this.querySelector(".loading-overlay__spinner").classList.add("hidden")
              autoAddedItem(this);
              autoAddItemOnValue();
          })
      }
  }
  handleErrorMessage(e = !1) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper"), this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"), this.errorMessageWrapper.toggleAttribute("hidden", !e), e && (this.errorMessage.textContent = e)
  }
});
class CartRemoveButton extends HTMLElement {
  constructor() {
      super(), this.addEventListener("click", e => {
          e.preventDefault(), this.closest(".cart_components").updateQuantity(this.dataset.index, 0)
      })

  }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartCloseButton extends HTMLElement {
  constructor() {

    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelector('#cart-drawer').classList.toggle('show');
      document.getElementsByTagName('body')[0].classList.toggle('stop_scrolling');
      $('.cart-drawer-overlay').addClass('overlay-hidden');
      console.log('console log')
    });
    this.addEventListener('close-cart-drawer', function(event){
      event.preventDefault();
      document.querySelector('#cart-drawer').classList.toggle('show');
      document.getElementsByTagName('body')[0].classList.toggle('stop_scrolling');
    })

  }
}
customElements.define("cart-close", CartCloseButton);
class CartItems extends HTMLElement {
  constructor() {
      super(), this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status"), this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce((e, t) => e + parseInt(t.value), 0), this.debouncedOnChange = debounce(e => {
          this.onChange(e)
      }, 300), this.addEventListener("change", this.debouncedOnChange.bind(this))
  }
  onChange(e) {
      this.updateQuantity(e.target.dataset.index, e.target.value, document.activeElement.getAttribute("name") , document.activeElement.getAttribute("up_qty"),document.activeElement.getAttribute("bundle"))
  }
  getSectionsToRender() {
      return [{
          id: "cart-template",
          section: document.getElementById("cart-template").dataset.id,
          selector: ".js-contents"
      }, {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section"
      }, {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section"
      }]
  }
  updateQuantity(line, quantity, name, upqty , bundle) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    
    checkcart(line,quantity,upqty);
   
    var lineId;
    fetch(`${window.internationalRoutes.cartUrl}`).then(response => response.json()).then(data =>{
      try{
        lineId = data.items[line-1].id  
      } catch {
        lineId = 0
      }
    })
    updatecart_count();
    fetch(`${window.internationalRoutes.changeUrl}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        updatecart_count();
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).finally(()=>{
        removeItem(quantity, lineId)
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      });
      

  }
  updateLiveRegions(e, t) {
      this.currentItemCount === t && (document.getElementById(`Line-item-error-${e}`).querySelector(".cart-item__error-text").innerHTML = window.cartStrings.quantityError.replace("[quantity]", document.getElementById(`Quantity-${e}`).value)), this.currentItemCount = t, this.lineItemStatusElement.setAttribute("aria-hidden", !0);
      let r = document.getElementById("cart-live-region-text");
      r.setAttribute("aria-hidden", !1), setTimeout(() => {
          r.setAttribute("aria-hidden", !0)
      }, 1e3)
  }
  getSectionInnerHTML(e, t) {
      return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML
  }
}
customElements.define("cart-items", CartItems);

class CartDrawer extends CartItems {
  constructor() {

    super();
    this.addEventListener('refresh-cart', function(){
      fetch(`${window.internationalRoutes.homeUrl}`).then(response => response.text()).then(data => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(data, 'text/html')
        let newCartDrawer = doc.querySelector('#cart-drawer').innerHTML;
        document.querySelector('#cart-drawer').innerHTML = newCartDrawer;
        try{
            updatecart_count()
        } catch{}
      })
    })
  }
  getSectionsToRender() {
      return [{
          id: "cart-drawer",
          section: document.getElementById("drawer-cart-items").dataset.id,
          selector: ".js-contents"
      }, {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section"
      }, {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section"
      }]
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartNote extends HTMLElement {
  constructor() {
      super(), this.addEventListener("change", debounce(e => {
          let t = JSON.stringify({
              note: e.target.value
          });
          fetch(`${window.internationalRoutes.updateUrl}`, {
              ...fetchConfig(),
              body: t
          })
      }, 300))
  }
}
customElements.define("cart-note", CartNote);
class FacetFiltersForm extends HTMLElement {
  constructor() {
      super(), this.onActiveFilterClick = this.onActiveFilterClick.bind(this), this.debouncedOnSubmit = debounce(e => {
          this.onSubmitHandler(e)
      }, 500), this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
      let e = this.querySelector("#FacetsWrapperDesktop");
      e && e.addEventListener("keyup", onKeyUpEscape)
  }
  static setListeners() {
      window.addEventListener("popstate", e => {
          let t = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
          t === FacetFiltersForm.searchParamsPrev || FacetFiltersForm.renderPage(t, null, !1)
      })
  }
  static toggleActiveFacets(e = !0) {
      document.querySelectorAll(".js-facet-remove").forEach(t => {
          t.classList.toggle("disabled", e)
      })
  }
  static renderPage(e, t, r = !0) {
      FacetFiltersForm.searchParamsPrev = e;
      let i = FacetFiltersForm.getSections();
      document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading"), i.forEach(r => {
          let i = `${window.location.pathname}?section_id=${r.section}&${e}`,
              s = e => e.url === i;
          FacetFiltersForm.filterData.some(s) ? FacetFiltersForm.renderSectionFromCache(s, t) : FacetFiltersForm.renderSectionFromFetch(i, t)
      }), r && FacetFiltersForm.updateURLHash(e)
  }
  static renderSectionFromFetch(e, t) {
      fetch(e).then(e => e.text()).then(r => {
          let i = r;
          FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
              html: i,
              url: e
          }], FacetFiltersForm.renderFilters(i, t), FacetFiltersForm.renderProductGridContainer(i)
      })
  }
  static renderSectionFromCache(e, t) {
      let r = FacetFiltersForm.filterData.find(e).html;
      FacetFiltersForm.renderFilters(r, t), FacetFiltersForm.renderProductGridContainer(r)
  }
  static renderProductGridContainer(e) {
      document.getElementById("ProductGridContainer").innerHTML = new DOMParser().parseFromString(e, "text/html").getElementById("ProductGridContainer").innerHTML
  }
  static renderFilters(e, t) {
      let r = new DOMParser().parseFromString(e, "text/html"),
          i = r.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetSortingForm .js-filter"),
          s = e => {
              let r = t ? t.target.closest(".js-filter") : void 0;
              return !!r && e.dataset.index === r.dataset.index
          },
          n = Array.from(i).filter(e => !s(e)),
          a = Array.from(i).find(s);
      n.forEach(e => {
          document.querySelector(`.js-filter[data-index="${e.dataset.index}"]`).innerHTML = e.innerHTML
      }), FacetFiltersForm.renderActiveFacets(r), FacetFiltersForm.renderAdditionalElements(r), a && FacetFiltersForm.renderCounts(a, t.target.closest(".js-filter"))
  }
  static renderActiveFacets(e) {
      [".active-facets-mobile", ".active-facets-desktop"].forEach(t => {
          let r = e.querySelector(t);
          r && (document.querySelector(t).innerHTML = r.innerHTML)
      }), FacetFiltersForm.toggleActiveFacets(!1)
  }
  static renderAdditionalElements(e) {
      [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach(t => {
          e.querySelector(t) && (document.querySelector(t).innerHTML = e.querySelector(t).innerHTML)
      })
  }
  static renderCounts(e, t) {
      let r = t.querySelector(".facets__selected"),
          i = e.querySelector(".facets__selected");
      i && r && (t.querySelector(".facets__selected").outerHTML = e.querySelector(".facets__selected").outerHTML)
  }
  static updateURLHash(e) {
      history.pushState({
          searchParams: e
      }, "", `${window.location.pathname}${e&&"?".concat(e)}`)
  }
  static getSections() {
      return [{
          section: document.getElementById("product-grid").dataset.id
      }]
  }
  onSubmitHandler(e) {
      e.preventDefault();
      let t = new FormData(e.target.closest("form")),
          r = new URLSearchParams(t).toString();
      FacetFiltersForm.renderPage(r, e)
  }
  onActiveFilterClick(e) {
      e.preventDefault(), FacetFiltersForm.toggleActiveFacets();
      let t = -1 == e.currentTarget.href.indexOf("?") ? "" : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
      FacetFiltersForm.renderPage(t)
  }
}
FacetFiltersForm.filterData = [], FacetFiltersForm.searchParamsInitial = window.location.search.slice(1), FacetFiltersForm.searchParamsPrev = window.location.search.slice(1), customElements.define("facet-filters-form", FacetFiltersForm), FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
      super(), this.querySelectorAll("input").forEach(e => e.addEventListener("change", this.onRangeChange.bind(this))), this.setMinAndMaxValues()
  }
  onRangeChange(e) {
      this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues()
  }
  setMinAndMaxValues() {
      let e = this.querySelectorAll("input"),
          t = e[0],
          r = e[1];
      r.value && t.setAttribute("max", r.value), t.value && r.setAttribute("min", t.value), "" === t.value && r.setAttribute("min", 0), "" === r.value && t.setAttribute("max", r.getAttribute("max"))
  }
  adjustToValidValues(e) {
      let t = +e.value,
          r = +e.getAttribute("min"),
          i = +e.getAttribute("max");
      t < r && (e.value = r), t > i && (e.value = i)
  }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
  constructor() {
      super(), this.querySelector("a").addEventListener("click", e => {
          e.preventDefault();
          let t = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
          t.onActiveFilterClick(e)
      })
  }
}
customElements.define("facet-remove", FacetRemove);
class SlickSlider extends HTMLElement {
  constructor() {
      if (super(), this.slider = this.querySelector('[id^="Slider-"]'), this.slider) {
          this.initPages();
          let e = new ResizeObserver(() => this.initPages());
          e.observe(this.slider)
      }
  }
  initPages() {
      let e = this.slider.id,
          t = this.slider.closest(".slider-container").querySelector(".activate-arrows");
      this.slider.classList.contains("product_thumb_img_qv") ? $("#" + e).not(".slick-initialized").slick({
          appendArrows: t,
          prevArrow: '<span class="arrow-slider arrow-prev"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 13L2 7L8 1" stroke="#A7822E" stroke-width="1.5"></path></svg></span>',
          nextArrow: '<span class="arrow-slider arrow-next"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L1 13" stroke="#A7822E" stroke-width="1.5"></path></svg></span>'
      }) : this.slider.classList.contains("product_thumb_img") ? $("#" + e).not(".slick-initialized").slick({
          appendArrows: t,
          nextArrow: '<span class="thumb-arrow-slider arrow-prev"><svg width="39" height="21" viewBox="0 0 39 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L18.8393 19L38 1" stroke="#A7822E" stroke-width="2" stroke-linecap="round"/></svg></span>',
          prevArrow: '<span class="thumb-arrow-slider arrow-next"><svg width="39" height="21" viewBox="0 0 39 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M38 20L20.1607 2L1 20" stroke="#A7822E" stroke-width="2" stroke-linecap="round"/></svg></span>'
      }) : this.slider.classList.contains("story-single-card-wrapper") ? (console.log("golden arrow"), $("#" + e).not(".slick-initialized").slick({
          appendArrows: t,
          nextArrow: '<span class="thumb-arrow-slider arrow-prev"><svg width="21" height="39" viewBox="0 0 21 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 38L19 20.1607L1 1" stroke="#A7822E" stroke-width="2" stroke-linecap="round"/></svg></span>',
          prevArrow: '<span class="thumb-arrow-slider arrow-next"><svg width="21" height="39" viewBox="0 0 21 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 1L2 18.8393L20 38" stroke="#A7822E" stroke-width="2" stroke-linecap="round"/></svg></span>'
      })) : $("#" + e).not(".slick-initialized").slick({
          appendArrows: t,
          prevArrow: '<span class="arrow-slider arrow-prev"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 13L2 7L8 1" stroke="black" stroke-width="2"/></svg></span>',
          nextArrow: '<span class="arrow-slider arrow-next"><svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L1 13" stroke="black" stroke-width="2"/></svg></span>'
      })
  }
}
customElements.define("slick-slider", SlickSlider);
document.dispatchEvent(new Event('gallery:sliders:initiated'));

class ChangeInput extends HTMLElement {
  constructor() {
      super(), this.input = this.querySelector(".selector_input"), this.select = this.querySelector(".selector_select"), this.select.addEventListener("change", this.changeInput.bind(this))
  }
  changeInput() {
      let e = this.select.value;
      this.input.value = e
  }
}
customElements.define("change-input", ChangeInput);

// onclick for Alia Pop up from placements where html can be added
function aliaPopupLaunch(id) {
  window.alia.push({
  type: "open",
  campaignID: id
  })
};

// Alia pop up for URL fields in the theme editor
document.addEventListener('DOMContentLoaded', function() {
  const aliaLinks = document.querySelectorAll('.alia-popup-trigger');

  aliaLinks.forEach(link => {
    const href = link.getAttribute('href');

    // Use a custom identifier to signal this link is a popup trigger
    if (href && href.includes('#alia')) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const campaignID = link.dataset.campaignId;
        if (window.alia && typeof window.alia.push === 'function') {
          window.alia.push({
            type: "open",
            campaignID: campaignID
          });
        } else {
          console.warn("Alia is not loaded yet.");
        }
      });
    }
  });
});
